<template>
  <div class="rayleigh-taylor-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>At = (ρ2-ρ1)/(ρ2+ρ1) | 重流体在轻流体之上$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Heavy Fluid (Dark Blue) -->
          <path :d="heavyPath" fill="#1e3799" opacity="0.8" />
          
          <!-- Light Fluid (Light Blue) -->
          <path :d="lightPath" fill="#48dbfb" opacity="0.4" />

          <!-- Interface Line -->
          <path :d="interfacePath" fill="none" stroke="#fff" stroke-width="2" />
          
          <text x="20" y="30" fill="#1e3799" font-size="8">重流体 (ρ2)</text>
          <text x="20" y="220" fill="#48dbfb" font-size="8">轻流体 (ρ1)</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>状态: {{ active ? '不稳定扰动增长中' : '静态平衡' }}</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
           <el-button type="primary" size="mini" @click="active = !active">{{ active ? '暂停' : '开始擾動' }}</el-button>
           <el-button size="mini" @click="t = 0; active = false">重置</el-button>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>瑞利-泰勒不稳定性（Rayleigh-Taylor Instability）发生在两种不同密度的流体之间，当较重的流体位于较轻的流体之上且面临重力（或等效加速度）时。界面上的微小微波会呈指数级增长，形成标志性的“蘑菇云”或“指状”下沉结构。这是天体物理（超新星爆发）、惯性约束聚变以及大气动力学中的核心不稳定过程。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RayleighTaylorViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      t: 0,
      active: false,
      timer: null
    }
  },
  computed: {
    interfacePath() {
       let points = [];
       // A(t) = A0 * cosh(gamma * t)
       let amp = this.active ? Math.exp(this.t * 0.05) * 2 : 2;
       if (amp > 100) amp = 100;

       for (let x = 0; x <= 400; x += 10) {
          let y = 120 + Math.sin(x * 0.05) * amp;
          points.push(`${x},${y}`);
       }
       return "M " + points.join(" L ");
    },
    heavyPath() {
       return this.interfacePath + " L 400,0 L 0,0 Z";
    },
    lightPath() {
       return this.interfacePath + " L 400,240 L 0,240 Z";
    }
  },
  methods: {
    update() {
       if (this.active) this.t += 1;
       this.timer = requestAnimationFrame(this.update);
    }
  },
  mounted() { this.update(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.rayleigh-taylor-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.02); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(30, 55, 153, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
